import { b2x } from '@b2x/react/src';

import { Box } from '../Box';
import { RegistrationFormContentType } from '../contentTypes';
import { CustomerEmployeeForm } from '../forms/CustomerEmployeeForm';
import { Page } from './Page';

export interface RegistrationEmployeePageProps {}

export const RegistrationEmployeePage = (props: RegistrationEmployeePageProps) => {
  const content = b2x.useContent<RegistrationFormContentType>('REGISTRATION_EMPLOYEE_FORM_CONTENT');

  return (
    <Page thingsToLoadBeforePageReady={[content]}>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-12 col-lg-8">
            <Box>
              <div className="mb-4 text-center">
                <h1 className="h2 fw-bold mb-2">{b2x.formatHtml(content?.body.title)}</h1>
                <p className="mb-0">{b2x.formatHtml(content?.body.subTitle)}</p>
              </div>
              <CustomerEmployeeForm
                minAge={18}
                successfulRegistrationModalProps={{
                  children: b2x.formatHtml(content?.body.modal?.content),
                  title: content?.body.modal?.title,
                }}
              />
            </Box>
          </div>
        </div>
      </div>
    </Page>
  );
};
